import { render } from "./BookingFlow.vue?vue&type=template&id=83928b0e"
import script from "./BookingFlow.vue?vue&type=script&lang=js"
export * from "./BookingFlow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__